<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/coursetypegroups/edit/' + coursetypegroup.id,
          props: { id: coursetypegroup.id }
        }"
        v-if="$can('coursetypegroup-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(coursetypegroup.id)" v-if="$can('coursetypegroup-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="coursetypegroup.name"
                  v-model="coursetypegroup.name"
                  :label="$t('coursetypegroups.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetypegroup.category"
                  v-model="coursetypegroup.category"
                  :label="$t('coursetypegroups.category')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetypegroup.type"
                  :value="this.$dd_course_type_groups_type(coursetypegroup.type)"
                  :label="$t('coursetypegroups.type')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="coursetypegroup.status"
                  :value="this.$dd_course_type_groups_status(coursetypegroup.status)"
                  :label="$t('coursetypegroups.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense flat color="secondary">
            <v-toolbar-title class="subheading">{{ $t("coursetypes.title") }}</v-toolbar-title>
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="headers"
                  :items="coursetypes"
                  :items-per-page="coursetypes.length"
                  :options.sync="pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="total"
                  :loading="show_loading"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.coursetypegroup_id="{ item }">
                    {{ item.coursetypegroup.name }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    {{ $dd_course_type_groups_status(item.status) }}
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "CourseTypesView",

  props: ["id"],

  data() {
    return {
      page_title: "",
      coursetypegroup: {},
      coursetypes: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      headers: [
        { text: this.$t("coursetypes.id"), value: "id" },
        { text: this.$t("coursetypes.name"), value: "name" },
        { text: this.$t("coursetypes.category"), value: "category" },
        {
          text: this.$t("coursetypegroups.title"),
          value: "coursetypegroup_id"
        },
        { text: this.$t("coursetypes.status"), value: "status" }
      ]
    }
  },

  created() {
    axios
      .get(this.API_URL + "coursetypegroup/" + this.id)
      .then((res) => {
        this.coursetypegroup = res.data.data
        this.page_title = this.$t("coursetypegroups.view_coursetypegroup", {
          name: this.coursetypegroup.name
        })

        this.coursetypes_list()
      })
      .catch((err) => console.log(err))
  },

  methods: {
    coursetypes_list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, {
        coursetypegroup_id: this.coursetypegroup.id
      })

      axios
        .get(this.API_URL + "coursetypes" + "?" + query)
        .then((res) => {
          this.coursetypes = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetypegroup/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetypegroups")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh && this.coursetypegroup.id) {
          this.coursetypes_list()
        }
      }
    },
    pagination: {
      handler() {
        this.refresh = true
      }
    }
  }
}
</script>

<style scoped></style>
